import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import NewsTagCreateEditForm from './Components/NewsTagCreateEditForm';
import NewsTagApi from './NewsTagApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: NewsTagCreateEditForm,
                getCreate: NewsTagApi.create,
                defaults: {},
                successMessage: "NewsTag Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}